import request from '@/utils/request'

const UserAPI = {
    // 登录
    login(data) {
        return request({
            url: '/api/project-management/external-user/login',
            method: 'post',
            data
        });
    },
    //登出
    logout() {
        return request({
            url: '/api/project-management/external-user/logout',
            method: 'post',
        });
    },
    changePassword(data) {
        return request({
            url: '/api/project-management/external-user/changePassword',
            method: 'post',
            data
        });
    }
}

export default UserAPI
